export default Object.freeze({
  NEW_TAB: '주문상세창 탭으로 띄우기',
  TAB: '주문상세창 하나의 탭으로 띄우기',
  NEW_WINDOW: '주문상세창 새창으로 띄우기',
  WINDOW: '주문상세창 하나의 새창으로 띄우기',
});
